import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { PROPOSAL_ID_PARAM, getProposalIdFromSearch } from "@utils/assignmentProposal";

/**
 * Keeps the proposalId of the URL equal to the proposal the editor is bound to, without a history
 * entry: a save can answer with a new id, and a reload must open that one. A regular entry has no
 * such parameter and is never touched.
 */
export const useSyncProposalUrl = () => {
  const history = useHistory();

  return useCallback(
    (proposalId: string | null | undefined) => {
      const location = history.location;
      const current = getProposalIdFromSearch(location.search);

      if (!proposalId || !current || current === proposalId) return;

      const params = new URLSearchParams(location.search);
      params.set(PROPOSAL_ID_PARAM, proposalId);
      history.replace({ ...location, search: `?${params.toString()}` });
    },
    [history],
  );
};
